export const getButtonType = (link: string) => {
  if (link) {
    const regex = new RegExp('^(http|https)://|(mailto|tel):', 'i')
    return regex.test(link) ? 'href' : 'to'
  }

  return null
}
